import jQuery from 'jquery'
import * as lib from '../lib/lib'

export default class AnchorTo {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.$element.on('click', (e) => {
      e.preventDefault()

      const targetElement = jQuery(e.currentTarget)
      const id = targetElement.data('id')
      const offsetY = targetElement.data('offset-y')
        ? targetElement.data('offset-y')
        : 50

      if (!id) {
        return false
      }

      const element = jQuery(`#${id}`)

      if (!element.length) {
        return false
      }

      lib.scrollToElem(element, offsetY)
    })
  }
}
